<template>
  <div class="inline-block w-full">
    <!-- {{get_platform_modules_item_data}} -->
    <vs-button
      @click="openMenu"
      class="left-menu-btn"
      :class="{ show: openLeftMenu }"
      icon="keyboard_arrow_right"
    ></vs-button>
    <div class="left-chart-menu" :class="{ show: openLeftMenu }">
      <vs-card>
        <!-- <pre>{{get_platform_modules_item_data}}</pre> -->
        <vs-collapse>
          <vs-collapse-item
            v-for="(eachGraph, index) in get_platform_modules_item_data"
            :key="index"
            @click.native="
              () => getIndividualSaveApi(eachGraph.platform_modules_id, index)
            "
          >
            <div slot="header">{{ eachGraph.module_name }}</div>
            <ul>
              <li
                v-for="(eachLineChart, dataIndex) in eachGraph.data"
                :key="dataIndex"
                @click.stop="
                  getGenratedSaveData(
                    eachLineChart.id,
                    eachLineChart.graph_type
                  )
                "
              >
                <div class="flex justify-between items-center mb-4">
                  <span>{{ eachLineChart.name }} ({{eachLineChart.graph_type}}) </span>
                  
                  <!-- {{eachLineChart.description}} -->
                  <div class="flex">
                  <vx-tooltip :text="eachLineChart.description" position="top">
                    <feather-icon icon="GridIcon" class="cursor-pointer" />
                  </vx-tooltip>

                  <vs-button
                  v-if="checkDeletePermission()"
                  class="ml-2"
                    icon-pack="feather"
                    color="danger"
                    icon="icon-trash-2"
                    @click.stop="
                      deleteGraph(dataIndex, index, eachLineChart.id)
                    "
                  ></vs-button>
                  </div>
                </div>
              </li>

              <li v-if="!eachGraph.data.length">No Data</li>
            </ul>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </div>
    <div class="chart-wrapper">
      <div id="chart">
        <vs-row>
          <vs-col class="px-2" vs-w="12">
            <line-graph
              :platform_modules="get_platform_modules_item_data"
              :SelectedLineGraphId="SelectedLineGraphId"
              id="line"
            ></line-graph>
          </vs-col>
          <vs-col class="px-2" vs-w="12">
            <!-- {{SelectedBarGraphId}} -->
            <bar-graph
              :platform_modules="get_platform_modules_item_data"
              :SelectedBarGraphId="SelectedBarGraphId"
              id="bar"
            ></bar-graph>
          </vs-col>

          <vs-col class="px-2" vs-w="12">
            <column-chart
              :platform_modules="get_platform_modules_item_data"
              :SelectedColumnGraphId="SelectedColumnGraphId"
              id="column"
            ></column-chart>
          </vs-col>

          <vs-col class="px-2" vs-w="12">
            <radar-chart
              :platform_modules="get_platform_modules_item_data"
              :SelectedRadarGraphId="SelectedRadarGraphId"
              id="radar"
            ></radar-chart>
          </vs-col>

          <vs-col class="px-2" vs-w="12">
            <!-- {{SelectedPieGraphId}} -->
            <pie-chart
              :platform_modules="get_platform_modules_item_data"
              :SelectedPieGraphId="SelectedPieGraphId"
              id="pie"
            ></pie-chart>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import LineGraph from './components/LineGraph.vue'
import BarGraph from './components/BarGraph.vue'
import ColumnChart from './components/ColumnChart.vue'
import PieChart from './components/PieChart.vue'
import RadarChart from './components/RadarChart.vue'

import { GraphMixins } from './mixins/GraphMixins'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  components: {
    apexchart: VueApexCharts,
    vSelect,
    LineGraph,
    BarGraph,
    ColumnChart,
    PieChart,
    RadarChart
  },
  mixins: [GraphMixins, PermissionMiddleware],
  async created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Analytics')
    }
    this.fetchPlatformModule()
    /*  const data = await fetchPieChart(localStorage.getItem('customer_id'))
    this.pieSeries = data.data.data.series
    this.pieChartOptions.labels = [...data.data.data.labels]

    
     */
  },
  data () {
    return {
      openGenerate: false,
      openLeftMenu: false,
      pieSeries: [],
      pieChartOptions: {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
      series: [
        {
          name: 'Desktops',
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Product Trends by Month',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep'
          ]
        }
      }
    }
  },
  methods: {
    openMenu () {
      this.openLeftMenu = !this.openLeftMenu
      document.body.classList.toggle('overflow-hidden')
    }
  }
}
</script>

<style>
.left-chart-menu {
  display: inline-block;
  vertical-align: top;
  width: 300px;
  position: fixed;
  height: 80vh;
  overflow: auto;
}
.left-chart-menu .con-content--item {
  padding: 0 1rem;
}
.left-chart-menu ul {
  padding-left: 12px;
}
.left-chart-menu li {
  list-style-type: disc;
}
.chart-wrapper {
  display: inline-block;
  width: calc(100% - 320px);
  margin-left: 320px;
}
.form_field_holder {
  transform: translateY(-170%);
  transition: transform 0.5s ease-in, position 0.5s ease-in;
  position: absolute;
  width: 100%;
  background: #f4f4f4;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 20px;
  z-index: -1;
  opacity: 0;
}
.form_field_holder.show {
  transform: translateY(0%);
  transition: transform 0.5s ease-in, position 0.5s ease-in;
  position: relative;
  z-index: 1;
  opacity: 1;
}
.left-menu-btn {
  display: none;
}
.left-menu-btn.show {
  transform: rotate(180deg);
}
.left-chart-menu .vs-collapse-item.open-item .vs-collapse-item--content {
  max-height: 100% !important;
}

@media (max-width: 900px) {
  .left-menu-btn {
    display: block;
    margin-bottom: 10px;
  }
  .left-chart-menu {
    transform: translateX(-150%);
    transition: all 0.5s ease-in;
  }
  .left-chart-menu.show {
    transform: translateX(0);
    transition: all 0.5s ease-in;
    width: calc(100% - 70px);
    height: 100%;
    z-index: 1000;
  }
  .left-chart-menu.show::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
    border-radius: 8px;
  }
  .chart-wrapper {
    margin-left: 0;
    width: 100%;
  }
}
.apexcharts-zoom-icon.apexcharts-selected svg {
  fill: rgba(var(--vs-primary), 1) !important;
}

.apexcharts-pan-icon.apexcharts-selected svg {
  stroke: rgba(var(--vs-primary), 1) !important;
}
</style>